import { Box, CircularProgress, Divider, Paper } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { sharedColors, sharedStyles } from '../../../utils/Style';
import { OrderStockHistory } from '../../../interfaces/Order/OrderStockHistory';
import { TableColumn } from '../../../components/DataTable/TableColumn';
import { TextColumn } from '../../../components/DataTable/TextColumn';
import { DataTable } from '../../../components/DataTable/DataTable';
import { getOrderStockHistory } from '../../../api/Order';

interface NameCellProps {
  row: OrderStockHistory;
}

const NameCell = (props: NameCellProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 0.3,
        cursor: 'pointer',
      }}
    >
      <Typography sx={{ ...sharedStyles.body1 }}>
        {props.row.productName}
      </Typography>

      {!!props.row.optionValueName && (
        <Typography sx={{ ...sharedStyles.body2, color: sharedColors.gray5 }}>
          {props.row.optionValueName}
        </Typography>
      )}
    </Box>
  );
};

const columns: TableColumn<OrderStockHistory>[] = [
  {
    id: 'name',
    name: 'Ürün',
    accessor: (row) => <NameCell row={row} />,
  },
  {
    id: 'old-stock',
    name: 'Sipariş Öncesi Stok',
    accessor: (row) => <TextColumn value={row.oldStock.toString()} />,
  },
  {
    id: 'new-stock',
    name: 'Sipariş Sonrası Stok',
    accessor: (row) => <TextColumn value={row.newStock.toString()} />,
  },
];

interface OrderStockHistoryTableProps {
  orderID: number;
}

export const OrderStockHistoryTable = ({
  orderID,
}: OrderStockHistoryTableProps) => {
  const [stockHistories, setStockHistories] = useState<OrderStockHistory[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getOrderStockHistory(orderID)
      .then((history) => setStockHistories(history))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  }, [orderID]);

  const handleClick = (row: OrderStockHistory) => {
    const url = `/products/catalog/${row.productID}`;
    window.open(url, '_blank');
  };

  return (
    <Paper
      sx={{
        p: 3,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
      }}
    >
      <Typography sx={{ ...sharedStyles.h5, fontWeight: 'bold' }}>
        Stok Hareketleri
      </Typography>

      <Divider />

      {loading ? (
        <Box
          sx={{
            p: 3,
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <DataTable
          columns={columns}
          onClick={handleClick}
          totalCount={stockHistories.length}
          rows={stockHistories}
          hidePagination
        />
      )}
    </Paper>
  );
};
